export default __webpack_public_path__ + "static/media/arrowRight.4f22e9b6.svg";